import { render, staticRenderFns } from "./SpeechBox.vue?vue&type=template&id=25e52a2f&scoped=true&"
import script from "./SpeechBox.vue?vue&type=script&lang=ts&"
export * from "./SpeechBox.vue?vue&type=script&lang=ts&"
import style0 from "./SpeechBox.vue?vue&type=style&index=0&id=25e52a2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e52a2f",
  null
  
)

export default component.exports